import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import TaxbillStaticsEmpRow from './TaxbillStaticsEmpRow';

const staticsOptions = [
  { name: '매출', value: 'sales' },
  { name: '매입', value: 'buy' },
  { name: '매출이익', value: 'profit' },
];

const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      border: '1px solid rgba(224, 224, 224, 1)',
    },
  },
});

const TaxbillStaticsEmpTable = ({
  selectedGbn,
  data,
  tableRef,
  headerRows,
}) => {
  const classes = useStyles();

  const [selectGbnName, setSelectGbnNm] = useState('매출');

  useEffect(() => {
    if (selectedGbn) {
      const findGbn = staticsOptions.find((item) => item.value === selectedGbn);
      setSelectGbnNm(findGbn.name);
    }
  }, [selectedGbn]);

  return (
    <Paper sx={{ overflow: 'auto', my: 1 }}>
      <TableContainer
        sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}
      >
        <Table size="small" className={classes.table} ref={tableRef}>
          <TableHead>
            <TableRow>
              <TableCell align="center" rowSpan={2}>
                본부
              </TableCell>
              <TableCell align="center" rowSpan={2}>
                팀
              </TableCell>
              <TableCell align="center" rowSpan={2}>
                팀원
              </TableCell>
              <TableCell align="center" colSpan={headerRows?.length}>
                {selectGbnName} 금액
              </TableCell>
            </TableRow>
            <TableRow>
              {headerRows &&
                headerRows.map((header, index) => {
                  return (
                    <TableCell key={index} align="center">
                      {header !== 'total' ? `${header}월` : `합계`}
                    </TableCell>
                  );
                })}
            </TableRow>
          </TableHead>
          <TableBody>
            {data === null || data.length === 0 ? (
              <TableRow>
                <TableCell colSpan={headerRows?.length + 3} align="center">
                  데이터가 없습니다.
                </TableCell>
              </TableRow>
            ) : (
              <TaxbillStaticsEmpRow data={data} headers={headerRows} />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default TaxbillStaticsEmpTable;
